import { render, staticRenderFns } from "./Coupon.html?vue&type=template&id=caf431aa&external"
import script from "./Coupon.js?vue&type=script&lang=js&external"
export * from "./Coupon.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports